import { PINNED } from '@private/data-grid';

import { IPaletteColor } from 'api/merchantTerminalThemes/types';
import { ISearchFilters } from 'components/Grids/DataGrid/Filters/utils/types';
import { THEME_VARIANT } from 'constants/defaultPalette';
import { LANGUAGES } from 'store/userConfiguration';
import { INullable } from 'utils/types';

export enum DECIMAL_SEPARATOR {
  APOSTROPHE = 'APOSTROPHE',
  COMMA = 'COMMA',
  DOT = 'DOT',
  SPACE = 'SPACE',
}

export enum THOUSANDS_SEPARATOR {
  APOSTROPHE = 'APOSTROPHE',
  COMMA = 'COMMA',
  NONE = 'NONE',
  SPACE = 'SPACE',
}

export interface IActivateFilterPayload {
  pageKey: string;
  presetId: INullable<string>;
}

export interface IActivePreset {
  activePreset?: INullable<string>;
}

export interface IAmountDisplayConfig {
  decimalSeparator: DECIMAL_SEPARATOR;
  thousandsSeparator: THOUSANDS_SEPARATOR;
}

export type IAmountDisplayPayload = IAmountDisplayConfig &
  ({ applyToAll: false; pageKey: string } | { applyToAll: true; pageKey?: never });

export interface IFilterPayload {
  columns?: INullable<IGridColumnsSettings>;
  filters?: INullable<ISearchFilters>;
  id?: INullable<string>;
  isRecent?: boolean;
  name?: string;
  pageKey: string;
  presetId?: string;
}

export interface IGridColumn {
  order: number;
  pinned?: PINNED;
  stretched: boolean;
  visible: boolean;
}

export type IGridColumnsSettings = Record<string, IGridColumn>;

export interface IOrganizationSettings {
  activeTheme: INullable<IOrganizationTheme>;
  createdAt: string;
  id: string;
  logo: string;
  name: string;
  organizationId: number;
  updatedAt: string;
}

export interface IOrganizationSettingsForm {
  logo: INullable<string>;
  name: INullable<string>;
  organizationId: INullable<number>;
}

export interface IOrganizationTheme {
  createdAt: string;
  id: string;
  name: string;
  organizationId: number;
  palette: IPalette;
  preview: string;
  updatedAt: string;
}

export interface IOrganizationThemePayload extends IOrganizationSettingsForm {
  canApply: boolean;
  palette: IPaletteColor[] | string;
  preview: string;
  themeId?: INullable<string>;
  themeName: string;
}

export interface IPageConfig {
  activePreset: INullable<string>;
  amountDisplay?: IAmountDisplayConfig;
  expandTable?: boolean;
  presets: ISavedPreset[];
}

export type IPagesConfigs = Record<string, IPageConfig>;

export type IPalette = IPaletteColor[] | string;

export interface IPortalUserConfig {
  settings: IPortalUserConfigSetting;
  systemSettings?: IPortalUserConfigSetting;
}

export interface ISavedPreset {
  columns?: IGridColumnsSettings;
  filters: ISearchFilters;
  id: string;
  isRecent?: boolean;
  isSystem?: boolean;
  name: string;
}

export interface IUserConfigPayload {
  customCalendarPeriodDays?: null | number;
  expandTable?: boolean;
  groupEditConfirmation?: boolean;
  hideMaxClientsStats?: boolean;
  language?: LANGUAGES;
  pageKey?: string;
  recordsPerPage?: number;
  rulesetDefaultCopyInclude?: boolean;
  themeVariant?: THEME_VARIANT;
}

interface IPortalUserConfigSetting {
  customCalendarPeriodDays?: number;
  groupEditConfirmation: boolean;
  hideMaxClientsStats: boolean;
  language: LANGUAGES;
  pages: IPagesConfigs;
  recordsPerPage: number;
  rulesetDefaultCopyInclude: boolean;
  theme: THEME_VARIANT;
}
